import { render, staticRenderFns } from "./index.vue?vue&type=template&id=0864ad96&scoped=true&"
import script from "./index.vue?vue&type=script&lang=ts&"
export * from "./index.vue?vue&type=script&lang=ts&"
import style0 from "./index.vue?vue&type=style&index=0&id=0864ad96&lang=scss&scoped=true&"
import style1 from "./index.vue?vue&type=style&index=1&id=0864ad96&lang=scss&scoped=true&"
import style2 from "./index.vue?vue&type=style&index=2&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0864ad96",
  null
  
)

export default component.exports